import React from 'react';
import DatePicker from 'material-ui/DatePicker';
import {format, startOfDay, addDays, subDays} from 'date-fns';
import ViewChairsComponent from './components/view-chairs/index';
import ToolbarComponent from './components/toolbar/index';
import appointments from '../../../../../../services/appointments/index';
import AllChairs from './components/all-chairs/index';
const esLocale = require('date-fns/locale/es')

export default class PickDayComponent extends React.Component {
    state = {
        dateString: "",
        date: null,
        chair: 0,
        appointments: []
    }

    datePicker = React.createRef();

    componentWillMount() {
        let {timestamp, chair} = this.props.match.params

        var date = (!timestamp) ? startOfDay(new Date()) : startOfDay(new Date(Number(timestamp)))
        var newchair = (!chair) ? 0 : chair;
        var dateString = format(
            date,
            "DD/MM/YYYY",
            {locale: esLocale},
        )
        appointments.find({date: date.getTime().toString()}, (err,data) => {
            this.setState({dateString: dateString, date: date, chair: newchair, appointments: data});
            this.props.history.push("/home/pick-day");
        })
    }

    openDatePicker = () => {
        this.datePicker.openDialog()
    }

    handleChange = (event, date) => {
        appointments.find({date: startOfDay(date).getTime().toString()}, (err,data) => {
            this.setState({
                date: startOfDay(date),
                dateString: format(
                    date,
                    "DD/MM/YYYY",
                    {locale: esLocale},
                ),
                chair: 0,
                appointments: data
            });
        })
    };

    changeDay = (how) => {
        let newDate = (how=="next") ?
            startOfDay(addDays(this.state.date, 1)) :
            startOfDay(subDays(this.state.date, 1))
        this.handleChange(null, newDate);
    }

    changeChair = (chair) => {
        if(chair != this.state.chair)
            this.setState({chair: chair})
    }

    render() {
        return (
            <React.Fragment>
                <DatePicker style={{width: 0, height: 0, overflow: "hidden"}}
                    ref={ref => this.datePicker=ref} id="date-picker"
                    DateTimeFormat={this.props.format}
                    value={this.state.date}
                    onChange={this.handleChange}
                    cancelLabel="Cancelar"
                    locale={"es"}/>
                <ToolbarComponent changeDay={this.changeDay}
                    openDatePicker={this.openDatePicker}
                    dateString={this.state.dateString}
                    chair={this.state.chair}
                    changeChair={this.changeChair}
                />
                {this.state.chair == 0 ?
                <AllChairs {...this.props} appointments={this.state.appointments} date={this.state.date} /> :
                <ViewChairsComponent chair={this.state.chair}
                    date={this.state.date}
                    {...this.props}
                    appointments={this.state.appointments}
                />}
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/scenes/pick-day/index.js